const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'media',
		'upload',
		'plupload',
		'instant'
	],

	config: {
		mode: 'productAdditionalInformationImporter',
		secureRoute: '/~/mblx/productAdditionalInformationImporter',
		pluploaderConfig: {
			multi_selection: false,
			url: '/LTR/~/mblx/productAdditionalInformationImporter',
			filters: {
				max_file_size : '4500kb',
				mime_types: [
					{
						title: 'Files',
						extensions: 'csv,tsv'
					}
				]
			}
		}
	},

	methods: {

		beforeChunkUpload: function(file, post, a, b){
			// last chunk of upload file
			if((post || {}).chunk === (((post || {}).chunks || 0) - 1)){
				let statusController
				if((statusController = getComponent('statusController'))){
					statusController.showStatus('status.progress.import')
				}
			}
		},

		uploadComplete: function(){

			let statusController
			if((statusController = getComponent('statusController'))){
				statusController.removeStatus()
			}

			const uploadResponse = this.model.lastResponse || {}
			const $results = this.$.find('.results')

			if($results.length < 1){
				console.error('results container missing')
				return
			}

			const messages = []
			const additionalClasses = []
			let success = false
			if (uploadResponse.errorCode) {
				messages.push(storage.__(`error:mblx.productAdditionalInformation.importerUploader.errorCodes.${uploadResponse.errorCode}`))
			} else if (uploadResponse.nrOfInvalidRows > 0) {
				messages.push(storage.__('error:mblx.productAdditionalInformation.importerUploader.nrOfInvalidRows', {...uploadResponse}))
			} else {
				messages.push(storage.__('productAdditionalInformation.importerUploader.success'))
				messages.push(storage.__('productAdditionalInformation.importerUploader.nrOfInserts', { ...uploadResponse }))
				messages.push(storage.__('productAdditionalInformation.importerUploader.nrOfUpdates', { ...uploadResponse }))

				const nrOfDuplicateNumbers = utils.collectionSize(uploadResponse.duplicateNumbers)
				if(nrOfDuplicateNumbers > 0){
					messages.push(storage.__('productAdditionalInformation.importerUploader.duplicateNumbers', { nrOfDuplicateNumbers, duplicateNumbers: uploadResponse.duplicateNumbers.join(', ') }))
				}
				success = true
			}

			if(!success){
				additionalClasses.push('error')
			}

			$results
				.html(`<ul>${messages.map(message => `<li>${message}</li>`).join('')}</ul>`)
				.removeClass('error success progress')
				.addClass(additionalClasses.join(' '))

			this.callHandler('onUploadComplete', [success])
		}
	}
}